import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../../services/apiService";
import {
  localDayEndToUtcDate,
  localDayStartToUtcDate,
} from "../../../services/dateUtils";
import { showSnackbar } from "../../snackbar/Snackbar.slice";

const GET_BUSINESS_REPORT = "businessReport/get";

export const getBusinessReport = createAsyncThunk(
  GET_BUSINESS_REPORT,
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const {
        token,
        page = 1,
        pageSize = 10,
        entityName,
        entityType,
        country,
        startDate,
        endDate,
      } = payload;

      const endpoint = "/report/business-report";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };

      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const params = {
        page,
        page_size: pageSize,
        entity_name: entityName,
        entity_type: entityType,
        country,
        start_date: startDate
          ? localDayStartToUtcDate(startDate, "YYYY-MM-DD")
          : startDate,
        end_date: endDate
          ? localDayEndToUtcDate(endDate, "YYYY-MM-DD")
          : endDate,
      };

      const queryString = new URLSearchParams();
      Object.keys(params).forEach((key) => {
        const value = params[key];
        if (value !== undefined && value !== null && value !== "") {
          queryString.set(key, value.toString());
        }
      });

      const fullEndpoint = queryString.toString()
        ? `${endpoint}?${queryString.toString()}`
        : endpoint;

      const response = await get(fullEndpoint, { headers });
      const entities = Array.isArray(response) ? response : response.entities || [];
      return {
        entities,
        page,
        pageSize,
        totalRecords:
          response.total_records ??
          (Array.isArray(response) ? response.length : entities.length),
      };
    } catch (error) {
      console.error("Error fetching business report thunk:", error);
      dispatch(
        showSnackbar({
          message: "Error cargando Business Report",
          severity: "error",
        }),
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
